<template>
    <div class="financeInfo">
        <div class="header__title">
            <h2>{{ dataFinanceSupport.title }}</h2>
            <p class="header__subline">{{ dataFinanceSupport.subline }}</p>
        </div>

        <v-layout wrap class="financeInfo__layout">
            <v-flex
                v-for="(item, index) in dataFinanceSupport.support"
                :key="index"
                class="financeInfo__cardWrap"
                xs12
                sm4
            >
                <div class="financeInfo__card">
                    <div>
                        <p class="h4">{{ item.title }}</p>
                        <p
                            v-if="item.text"
                            class="financeInfo__info text--large"
                        >
                            {{ item.text }}
                        </p>
                        <ul v-else-if="item.list">
                            <li v-for="(listItem, i) in item.list" :key="i">
                                <span v-if="listItem.label">
                                    {{ listItem.label }}
                                </span>
                                <span v-if="listItem.more">
                                    <a
                                        v-if="listItem.more.href"
                                        :href="listItem.more.href"
                                    >
                                        {{ listItem.more.label }}
                                    </a>
                                </span>
                            </li>
                        </ul>
                    </div>

                    <SVGIcon icon-name="circle-check" class="icon__chevron" />
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'

export default {
    name: 'FinanceInfo',

    components: {
        SVGIcon,
    },

    data: () => ({
        dataFinanceSupport: {
            title:
                'Mit Verhinderungspflege-Budget Ihre Alltagshilfe finanzieren',
            subline:
                'Sie haben die Möglichkeit, Kosten für Ihren Careship Alltagshelfer über die Verhinderungspflege zu finanzieren.',
            support: [
                {
                    title: 'Entlastungsbetrag',
                    list: [
                        { label: 'Ab Pflegegrad 1' },
                        {
                            label:
                                'In Berlin dauerhaft durch Careship Ambulant direkt mit der Pflegekasse abrechenbar – weitere Regionen folgen.',
                            more: {
                                label:
                                    'Jetzt mehr über Careship Ambulant erfahren!',
                                href:
                                    '/senioren-ratgeber/alltagshilfe-abrechnen',
                            },
                        },
                        {
                            label:
                                'Ab Pflegegrad 2 können Sie zusätzlich bis zu 40 % der Pflegesachleistungen in den Entlastungsbetrag umwandeln und diesen aufstocken.',
                        },
                    ],
                },
                {
                    title: 'Verhinderungspflege',
                    list: [
                        { label: 'Ab Pflegegrad 2' },
                        {
                            label:
                                'Eingetragene Pflegeperson bei der Pflegekasse seit mind. 6 Monaten.',
                        },
                    ],
                },
                {
                    title:
                        'Pflegesachleistungen in Entlastungsbetrag umwandeln',
                    list: [
                        { label: 'Ab Pflegegrad 2' },
                        {
                            label:
                                'Nicht zweckgebundenes Budget - Sie können das Pflegegeld zur Finanzierung von Careship-Leistungen nutzen.',
                        },
                    ],
                },
            ],
        },
    }),
}
</script>

<style lang="stylus">
.financeInfo {

    .header__subline {
        max-width: 760px;
    }

    &__layout {
        @media $display-breakpoints.sm-only {
            margin: 0 (-($cs-spaces.half));
        }

        @media $display-breakpoints.md-and-up {
            margin: 0 (-($cs-space));
        }
    }

    &__cardWrap {
        margin: 0 0 $cs-spaces.double;

        &:last-child {
            margin-bottom: 0;
        }

        @media $display-breakpoints.sm-and-up {
            margin: 0;
        }
    }

    &__card {
        background: $cs-slate-050;
        border-radius: $cs-border-radius;
        box-shadow: none;
        display: flex;

        padding: $cs-spaces.onehalf;
        justify-content: space-between;

        @media $display-breakpoints.sm-and-up {
            height: 100%;
            margin: 0 $cs-spaces.half;
        }

        @media $display-breakpoints.md-and-up {
            margin: 0 $cs-space;
        }

        .h4 {
            margin: 0 0 $cs-spaces.half;
        }

        ul {
            list-style-type: disc;
        }
    }

    &__info {
        margin: 0;
    }

    .icon__chevron {
        flex: 0 0 auto;
        height: 22px;
        margin: 0 0 0 $cs-spaces.half;
        transition: all 300ms ease-in-out;
        width: 22px;
    }
}
</style>
